/* eslint-disable func-names */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Route, Switch } from "react-router-dom";
import {
    Badge,
    Button,
    Card,
    Form,
    Navbar,
    Nav,
    Container,
    Row,
    Col,
    Table
  } from "react-bootstrap";

import { formatTime, getTranslate, LANGUAGE_KEYS, getDiffMinutesFromNowVN } from "../../utils";
import moment from "moment";


import {BsFillSuitHeartFill} from "react-icons/bs";
// https://react-icons.github.io/react-icons/icons?name=bs

class ShopItem extends Component {
  constructor() {
    super();
    this.state = {
      showQuickView: false
    };
  }

  componentDidMount() {
  }

  componentWillReceiveProps(props) {
  }

  lastSoldDay = (sale_90_days_list) => {
    var i = 0;

    while (sale_90_days_list[i] == 0 && i < sale_90_days_list.length - 1)
      i++;

    return i;
  }

  formatLastUpdateDays = (last_updated_days) => {
    var d = Math.floor(last_updated_days);
    var h = Math.round((last_updated_days - d) * 24);

    var str = "";

    if (d > 0)
      str += `${d} ${getTranslate(LANGUAGE_KEYS.TEXT_DAY)} `;

    str += `${h} ${getTranslate(LANGUAGE_KEYS.TEXT_HOUR)}`;
    
    return str;
  }

  handleQuickView = (e) => {
    e.stopPropagation();
    this.setState({ showQuickView: true });
  }

  handleCloseQuickView = (e) => {
    e.stopPropagation();
    this.setState({ showQuickView: false });
  }

  render() {
    var shop = this.props.shop;

    return (
      <>
        <Card id='shop-item' style={{ cursor: 'pointer' }}>
          <Card.Img 
            variant="top" 
            src={shop.img_shop_avatar_url || 'https://www.webike.vn/frontend/img/common/shop_default.jpg'} 
            onClick={() => window.open(`/admin/eit/listing?shop_id=${shop.shop_id}&shop_name=${encodeURIComponent(shop.shop_name)}`, '_blank')}
            style={{ cursor: 'pointer' }}
          />
          <Card.Title as="h5" className="pt-3 pl-3">
            <Badge pill bg={`${shop.status == 2? 'danger': 'success'}`} title={shop.status == 2? 'Suspended!': 'Active'} onClick={this.handleQuickView}>
              {shop.shop_name}
            </Badge>
          </Card.Title>
          <Card.Body>
              <Table>
                <tbody>
                  <tr>
                    <td>{getTranslate(LANGUAGE_KEYS.TEXT_TOTAL_SALES)}</td>
                    <td className="value">
                      <Badge pill bg="danger">
                        {shop.total_sales}
                      </Badge>
                    </td>
                  </tr>
                  <tr>
                    <td>{getTranslate(LANGUAGE_KEYS.TEXT_SHOP_SOLD_30_DAYS)}</td>
                    <td className="value">
                      <Badge pill bg="danger">
                        {shop.sale_30_days}
                      </Badge>
                    </td>
                  </tr>

                  <tr>
                    <td>{getTranslate(LANGUAGE_KEYS.TEXT_REVENUE_30_DAYS)}</td>
                    <td className="value">
                      <Badge pill bg="danger">
                        {shop.revenue_30_days_calculate !== undefined && shop.revenue_30_days_calculate !== null
                          ? `${Math.round(shop.revenue_30_days_calculate).toLocaleString('de-DE')} USD`
                          : '~'}
                      </Badge>
                    </td>
                  </tr>
                  <tr>
                    <td>{getTranslate(LANGUAGE_KEYS.TEXT_SALE_RATIO)}</td>
                    <td className="value">
                      <Badge pill bg="danger">
                        {shop.sale_per_views !== undefined && shop.sale_per_views !== null ? (shop.sale_per_views * 100).toFixed(2) + '%' : '~'}
                      </Badge>
                    </td>
                  </tr>

                  <tr>
                    <td>{getTranslate(LANGUAGE_KEYS.TEXT_RATING)}</td>
                    <td className="value">
                      <Badge pill bg="danger">
                        {`${Math.round(shop.rating_value * 100) / 100} ★`}
                      </Badge>
                    </td>
                  </tr>

                  <tr>
                    <td>{getTranslate(LANGUAGE_KEYS.TEXT_TOTAL_LISTINGS)}</td>
                    <td className="value">
                      <Badge pill bg="primary">
                        {shop.all_listing_ids.length}
                      </Badge>
                    </td>
                  </tr>

                  <tr>
                    <td>{getTranslate(LANGUAGE_KEYS.TEXT_OPENING_DATE)}</td>
                    <td className="value">
                      <Badge pill bg="primary">
                        {formatTime(shop.opening_date, "DD/MM/YYYY")}
                        {/* {moment(shop.opening_date).fromNow()} */}
                      </Badge>
                    </td>
                  </tr>

                  <tr>
                    <td>{getTranslate(LANGUAGE_KEYS.TEXT_LAST_UPDATE)}</td>
                    <td className="value">
                      <Badge pill bg="secondary">
                        {getDiffMinutesFromNowVN(shop.last_check_shop_info)}
                      </Badge>
                    </td>
                  </tr>

                  <tr>
                    <td>{getTranslate(LANGUAGE_KEYS.TEXT_CREATED_DATE)}</td>
                    <td className="value">
                      <Badge pill bg="secondary"
                        title={shop.created_at ? formatTime(shop.created_at, 'YYYY-MM-DD HH:mm:ss') : undefined}
                      >
                        {formatTime(shop.created_at, "DD/MM/YYYY")}
                      </Badge>
                    </td>
                  </tr>

                  {/* <tr>
                    <td>{getTranslate(LANGUAGE_KEYS.TEXT_UPDATED_AT)}</td>
                    <td className="value">
                      <Badge pill bg="secondary"
                        title={shop.updated_at ? formatTime(shop.updated_at, 'YYYY-MM-DD HH:mm:ss') : undefined}
                      >
                        {shop.updated_at ? formatTime(shop.updated_at, "DD/MM/YYYY") : '~'}
                      </Badge>
                    </td>
                  </tr> */}

                </tbody>
              </Table>
          </Card.Body>
          <Card.Footer className="text-center">
            <div className="d-flex justify-content-center gap-2">
              <Badge 
                pill 
                bg="primary" 
                onClick={(e) => {
                  e.stopPropagation();
                  window.open(`https://www.etsy.com/shop/${shop.shop_name}`, '_blank');
                }}
                style={{ cursor: 'pointer' }}
              >
                View on Etsy
              </Badge>
              <Badge 
                pill 
                bg="success" 
                onClick={(e) => {
                  e.stopPropagation();
                  window.open(`https://www.etsy.com/shop/${shop.shop_name}?run_step_2=true`, '_blank');
                }}
                style={{ cursor: 'pointer' }}
              >
                Update Insight
              </Badge>
            </div>
          </Card.Footer>
        </Card>

        {this.state.showQuickView && (
          <div 
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0,0,0,0.5)',
              zIndex: 1000,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
            onClick={this.handleCloseQuickView}
          >
            <div 
              style={{
                width: '90%',
                height: '90%',
                backgroundColor: 'white',
                borderRadius: '8px',
                position: 'relative'
              }}
              onClick={e => e.stopPropagation()}
            >
              <Button
                variant="danger"
                size="sm"
                style={{
                  position: 'absolute',
                  top: '10px',
                  right: '10px',
                  zIndex: 1001
                }}
                onClick={this.handleCloseQuickView}
              >
                ×
              </Button>
              <iframe
                src={`/admin/eit/listing?shop_id=${shop.shop_id}&shop_name=${encodeURIComponent(shop.shop_name)}&show_sidebar=false`}
                style={{
                  width: '100%',
                  height: '100%',
                  border: 'none',
                  borderRadius: '8px'
                }}
              />
            </div>
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
  };
};

export default connect(mapStateToProps, { })(ShopItem);